import script from "./TableMemoButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableMemoButton.vue?vue&type=script&setup=true&lang=ts"

import "./TableMemoButton.vue?vue&type=style&index=0&id=7e94e1bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e94e1bd"]])

export default __exports__